import { request } from "@/components/Joyspace/api/request";
import { joyspacePermissionType } from "../config/permissions.config";
import { FileType } from "../types";

export const applyApprove = (
  applyCode: string,
  // applyUserId: string,
  // permissionType: any,
  // applyReason: string,
  cardMsgId: string
  // eslint-disable-next-line max-params
) =>
  request({
    api: "joyspace.pageApply.approve",
    path: `/v1/pageApply/approve`,
    method: "POST",
    body: {
      applyCode,
      cardMsgId
      // pageId,
      // applyUserId,
      // applyReason,
      // permissionType,
    }
  });

export const applyReject = (
  applyCode: string,
  // applyUserId: string,
  // permissionType: any,
  // applyReason: string,
  cardMsgId: string
  // eslint-disable-next-line max-params
) =>
  request({
    api: "joyspace.pageApply.reject",
    path: `/v1/pageApply/reject`,
    method: "POST",
    body: {
      applyCode,
      cardMsgId
      // pageId,
      // applyUserId,
      // applyReason,
      // permissionType,
    }
  });

export const approval = (
  action: string,
  applyCode: string,
  extendParameters: string,
  cardMsgId: string
  // eslint-disable-next-line max-params
) =>
  request({
    api: "joyspace.apply.approval",
    path: `/v1/apply/approval`,
    method: "POST",
    body: {
      action,
      applyCode,
      cardMsgId,
      extendParameters
    }
  });

export const create = (
  pageId: string,
  applyType: FileType,
  permissionType: joyspacePermissionType,
  applyReason = ""
  // eslint-disable-next-line max-params
) =>
  request({
    api: "joyspace.pageApply.create",
    path: `/v1/pageApply/create`,
    method: "POST",
    body: {
      pageId,
      applyType,
      permissionType,
      applyReason
    }
  });

export const getOwner = (folderId = "") =>
  request({
    api: "joyspace.folder.owner",
    path: `/v1/folders/${folderId}/owner`,
    method: "GET"
  });
